import {isRouteErrorResponse, useRouteError} from "react-router-dom";
import React from "react";
import {BackHomeButton} from "./BackHomeButton";
import {NavigationError} from "./NavigationError";
import {AxiosError} from "axios";
import {ErrorPage, ErrorPageProps} from "./ErrorPage";

export default function ErrorPageBoundary() {
    const error = useRouteError();

    return (
        <ErrorPage {...toErrorPageProps(error)}/>
    );
}

export function toErrorPageProps(error: any): ErrorPageProps {
    let errorPageProps: ErrorPageProps
    if (error instanceof NavigationError) {
        errorPageProps = {
            title: error.status,
            header: error.statusText,
            description: error.message,
            action: error.action,
        };
    } else if (error instanceof AxiosError) {
        const navError = NavigationError.fromAxiosError(error);
        errorPageProps = toErrorPageProps(navError);
    } else if (isRouteErrorResponse(error)) {
        const navError = NavigationError.fromErrorResponse(error);
        errorPageProps = toErrorPageProps(navError);
    } else if (error instanceof Error) {
        errorPageProps = {
            title: 'Something went wrong',
            header: error.name,
            description: error.message,
            action: <BackHomeButton/>,
        }
    } else if (typeof error === 'string') {
        errorPageProps = {
            title: 'Something went wrong',
            description: error,
            action: <BackHomeButton/>,
        };
    } else {
        errorPageProps = {
            title: 'Unknown Error',
            description: error.toString(),
            action: <BackHomeButton/>,
        }
    }

    return errorPageProps;
}